export const MMKVEdTechStoreKeyMap = {
    edTechAppSettings: 'edTechAppSettings',
    productStore: 'productStore',
  };
  